import { useContext, useEffect, useState } from "react";
import { ProfileInterface as iData } from "../../interfaces";
import profileService from "../../services/ProfileService";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
    JCaption, JCard, JCardBody, JHeader, JPaginacao, JTable, JTBody, JTHead
} from "../../components/Components";
import { AuthContext } from "../../contexts/AuthContext";

export default function IndexProfile() {
    const [dados, setDados] = useState<iData[]>([]);
    const [showSpinner, setShowSpinner] = useState(true);
    const [search, setSearch] = useState('');
    const [meta, setMeta] = useState<any>(null)
    const [links, setLinks] = useState<any>(null)
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        searchFilter();

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [search]);


    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Insert') {
            navigate('/profile/create');
        }
    }

    const searchFilter = async (page: string | null = null) => {

        setShowSpinner(true);

        await profileService.getAllPaginate(search, page).then(response => {
            setDados(response.data);
            setLinks(response.links);
            setMeta(response.meta);
            setShowSpinner(false);

        }).catch(err => {
            if (err.response.status === 403) {
                authContext?.setShowError(true)
                authContext?.setShowMessageError(err.response.data.message);
                navigate('/');
            }
            setShowSpinner(false);
        });

    }

    const handlePageChange = (page: string | null = null) => {
        searchFilter(page)
    }

    return (
        <>
            
            <div className="row d-flex justify-content-between align-items-start g-2">
                <Col md>
                    <JCard>
                        <JHeader
                            urlCreate="/profile/create"
                            search={search}
                            setSearch={setSearch}
                            showSpinner={showSpinner}
                            permissionCreate={authContext?.userLogado.is_staff || authContext?.userLogado.is_superuser}
                            permissionSearch={authContext?.userLogado.is_staff || authContext?.userLogado.is_superuser}
                        >

                        </JHeader>
                        <JCardBody>
                            <JCaption title="Lista de Perfis">

                                <JPaginacao
                                    links={links ?? {}}
                                    meta={meta ?? {}}
                                    handlePageChange={handlePageChange} />
                            </JCaption>
                            <JTable >

                                <JTHead>
                                    <tr>

                                        <th>Nome</th>
                                    </tr>
                                </JTHead>
                                <JTBody>
                                    {dados?.map((data) => (
                                        <tr key={data.id}>
                                            <td>
                                                {authContext?.userLogado.is_superuser === 1 && (
                                                    <Link title="Clique no nome para editar e ou remover" className="text-primary" to={`/profile/${data.id}`} style={{ textDecoration: 'none' }}>
                                                        {data.name}
                                                    </Link>
                                                )}

                                            </td>

                                        </tr>
                                    ))}
                                </JTBody>
                            </JTable>
                        </JCardBody>
                    </JCard>
                </Col>
            </div>
        </>
    );
};

